import LazyLoad from "react-lazyload";
import { Link } from 'react-router-dom'
const AimsObjectives = () => { 
  return (
    <>
      <div className="breadcrumb">
        <h2>Aims & Objectives</h2>
        <ul>
          <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
          <li>|</li> <li>About</li>
          <li>|</li>
          <li>Aims & Objectives</li>
        </ul>
      </div>
      <div className="inner_page">
        <div className="container">
            <div className="row">
            <div className="col-md-4"> 
                    <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/aims.jpg" alt="st francis school, Amritsar" className="img-fluid" /></LazyLoad>
                </div> 
                <div className="col-md-8">                    
                    <h3 className="heading">Aims & Objectives</h3>
                    <p>The aim of the school is to impart quality education designed for the all round development of the child. The students will be prepared for their future duties by a careful cultivation of their minds and hearts.</p>
                    <p>Children will be enlightened intellectually morally, socially, professionally and spiritually. Although it is a Christian Minority School, every student is encouraged to practice his/her religion.</p>
                    <p>Special emphasis is given for the practice of natural virtues like universal brotherhood, truthfulness, honesty, politeness, tolerance, simplicity, self- discipline and orderliness.</p>                   
                </div>
                
            </div>
        </div>
      </div>
    </>
  )
}

export default AimsObjectives
